import { NonReducibleUnknown, fromPromise } from 'xstate';

export function createNotImplementedActor<TResult, TInput = NonReducibleUnknown>() {
  return fromPromise<TResult, TInput>(async () => {
    throw new Error('Not implemented yet');
  });
}
